import React from "react";
import * as styles from "./NarrativeSection.module.scss";

export interface NarrativeRow {
  tag?: string;
  title: React.ReactNode;
  text: string;
  img: React.ReactNode;
  flip?: boolean; // image on the left
}

interface Props {
  heading?: string;
  rows: NarrativeRow[];
  footer?: React.ReactNode;
}

export const NarrativeSection: React.FC<Props> = ({ heading, rows, footer }) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {heading && <h2 className={styles.sectionHeading}>{heading}</h2>}
        {rows.map((row, i) => (
          <div
            key={i}
            className={`${styles.row} ${row.flip ? styles.rowFlip : ""}`}
          >
            <div className={styles.imgCol}>{row.img}</div>
            <div className={styles.textCol}>
              {row.tag && <span className={styles.tag}>{row.tag}</span>}
              <h2 className={styles.title}>{row.title}</h2>
              <div className={styles.text}>
                {row.text.split("\n\n").map((para, j) => (
                  <p key={j}>{para}</p>
                ))}
              </div>
            </div>
          </div>
        ))}
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </section>
  );
};

export default NarrativeSection;
